import "core-js/modules/es.array.filter.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'SidebarItemForChoose',
  props: {
    children: {
      type: String
    },
    route: {
      type: Object
    },
    isNest: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    routes: function routes() {
      console.log(this.route);
      console.log(this.route.children);
      return this.route.children;
    }
  },
  methods: {
    getQuery: function getQuery(data) {
      var str = '';

      if (data !== undefined) {
        for (var st in data.query) {
          if (str === '') {
            str += st + '=' + data.query[st];
          } else {
            str += '&' + st + '=' + data.query[st];
          }
        }
      }

      return str;
    },
    hasOneShowingChildren: function hasOneShowingChildren(children) {
      var showingChildren = children.filter(function (item) {
        return !item.hidden;
      });

      if (showingChildren.length === 1) {
        return true;
      }

      return false;
    },
    handleRouteLink: function handleRouteLink(route) {
      console.log('route', route);
    }
  }
};